import { 
  Shield, 
  Monitor,
  Activity
} from "lucide-react";
import type { MenuItem } from "../types";

export const systemSecuritySection: MenuItem = {
  title: "أمان النظام",
  href: "#",
  icon: Shield,
  color: "from-red-500 to-red-600",
  permission: "مراقبة النظام",
  subItems: [
    {
      title: "فحص صحة النظام",
      href: "/system-health",
      icon: Activity,
      color: "from-green-500 to-green-600",
      permission: "مراقبة النظام",
    },
    {
      title: "مراقبة النظام",
      href: "/system-monitoring",
      icon: Monitor,
      color: "from-blue-500 to-blue-600",
      permission: "مراقبة النظام",
    }
  ]
};